/**
 * Breadcrumb - Navegación de breadcrumb para recepción de devoluciones
 *
 * Componente de navegación que muestra la ruta actual en el proceso
 * de recepción de devoluciones. Incluye:
 * - Navegación entre diferentes vistas de recepción
 * - Información del estado y código de entrada
 * - Estilos consistentes con el diseño del sistema
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useIsMobile } from '@shared/hooks/useMobile';
import { getReturnedStatusName, getReturnedStatusBadgeClass } from '../../../List/config';

interface BreadcrumbProps {
  returnedId: number;
  code: string;
  status: number;
}

export const Breadcrumb = ({ returnedId, code, status }: BreadcrumbProps) => {
  const { t } = useTranslation('returnedModule');
  const isMobile = useIsMobile();

  const breadcrumbs = useMemo(
    () => [
      // Solo mostrar "Devoluciones" en desktop
      ...(isMobile ? [] : [{ label: t('breadcrumb.returned'), path: '/returned' }]),
      {
        label: (
          <div className="flex items-center gap-2">
            <span className="text-text">{code}</span>
            <span
              className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getReturnedStatusBadgeClass(status)}`}
            >
              {getReturnedStatusName(status, t)}
            </span>
          </div>
        ),
      },
    ],
    [returnedId, code, status, t, isMobile],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
